import Vue from 'vue'

const numberUtil = {
  /**
   * 将数字变成两位小数的金钱格式
   * @param {Number} number 需处理字符串
   * @returns {String} money
   */
  toMoney (number) {
    if (isNaN(number) || number.length === 0) {
      return
    } else {
      return Number(number).toFixed(2)
    }
  }
}

Vue.prototype.$number = numberUtil